<div class="content">
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-8 col-md-8 col-sm-8 common_title">
          <h2>ANIMAL MANAGEMENT MODULE</h2>
          <p>Animal list</p>
          <!--<a href="#" class="back_to"><i class="fa fa-chevron-left" aria-hidden="true"></i>
      Back
     </a>-->
        </div>
        <div class="col-lg-2 col-sm-2 col-12 common_title1" [class.disablebutton]="isDisabled">
          <div class="form-group">
            <label for="Breed Name" style="visibility: hidden;">add</label>
            <button class="btn btn-primary mt-0 mb-0 add" (click)="addstockmanagement()"><i class="fa fa-plus"
                aria-hidden="true"></i> <span class="lengthchange">Add animal</span></button>
          </div>
        </div>
        <div class="col-lg-2 col-sm-2 col-12 common_title1" [class.disablebutton2]="isDisabledview">
          <div class="form-group">
            <label for="Breed Name" style="visibility: hidden;">add</label>
            <button class="btn btn-primary mt-0 mb-0 add" (click)="view_table()"><span class="lengthchange">view
                all&nbsp; animals</span></button>
          </div>
        </div>
      </div>
      <div class="row ">
        <div class="col-lg-3 col-md-6 col-sm-12 ">
          <div class="form-group multiple">
            <label for="Species Name">Farm Name</label>
            <select name="farmname" id="farmname" class="form-control selectpicker myFakeClass"
              (change)="getfarmvalue($event)">
              <option selected disabled val="">Select Farm Name</option>
              <option *ngFor='let farmlist of getfarmsListData' [value]="farmlist.tnfr_id">{{farmlist.tnfr_name}}
              </option>
            </select>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-12">
          <div class="form-group">
            <label for="Species Name">Species Name</label>
            <select id="Speciesname" name="Speciesname" class="selectpicker form-control myFakeClass1"
              (change)="breedselectbyspecies($event)">
              <option val="" selected disabled="disabled">Select species</option>
              <option *ngFor='let specieslist of speciesloaddata' [value]="specieslist.id">{{specieslist.name}}</option>
            </select>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-12">
          <div class="form-group">
            <label for="Breed Name">Breed Name</label>
            <select id="BreedName" class="selectpicker form-control myFakeClass2" (change)="loadanimaldata($event)">
              <option selected disabled val="">Select Breeds</option>
              <option *ngFor='let breedname of getbreedvalue' [value]="breedname.id">{{breedname.name}}</option>
            </select>
          </div>
        </div>
        <div class="col-lg-2 col-md-6 col-sm-6 ">
          <div class="form-group">
            <label for="Species Name">Age Group</label>
            <select id="agetype" class="selectpicker form-control myFakeClass3" (change)="selectagegroup($event)">
              <option selected disabled val="">Select Age</option>
              <option *ngFor='let agelist of loadagegroupvalue ' [value]="agelist.tnag_id">{{agelist.tnag_name}}
              </option>
            </select>
          </div>
        </div>
        <div class="col-lg-1 col-sm-1 col-12 text-center">
          <div class="form-group">
            <label for="Breed Name"></label>
            <span class="input-group-btn">
              <button class="btn btn-primary search" type="button" (click)="showtabledataa()"><span
                  class="fa fa-search"></span>Filter</button>
            </span>
          </div>

        </div>
        <div class="col-lg-2 col-sm-6 col-12" [class.disablebutton]="isDisabled">
          <div class="form-group">
            <label>Export XLSX Data</label>
            <select id="export" class="selectpicker form-control myFakeClass4" (change)="Exportdata($event)"
              style="overflow:hidden" data-size="5">
              <option selected disabled val="">Export XLSX Data</option>
              <option value="General">General</option>
              <option value="Vaccine">Vaccine</option>
              <option value="Disease">Disease</option>
              <option value="Samples">Samples</option>
              <option value="Diagnostic">Diagnostic</option>
              <option value="Deworming">Deworming</option>
              <option value="Death">Death</option>
            </select>
          </div>
        </div>

        <!--button for export-->
        <div class="col-lg-1 col-sm-6 col-12" [class.disablebutton3]="disablebutton3" style="
margin-top: 25px;
">
          <div class="form-group" *ngIf="selectedValue3 == 'General'">
            <div class="form-group">
              <button class="btn btn-primary mt-0 mb-0 download" (click)="exportGeneral()"><i
                  class="fa fa-download"></i></button>
            </div>
          </div>
          <div class="form-group" *ngIf="selectedValue3 == 'Vaccine'">
            <div class="form-group">
              <button class="btn btn-primary mt-0 mb-0 download" (click)="exportvaccinedata()"><i
                  class="fa fa-download"></i></button>
            </div>
          </div>
          <div class="form-group" *ngIf="selectedValue3 == 'Disease'">
            <div class="form-group">
              <button class="btn btn-primary mt-0 mb-0 download" (click)="exportdiseasedata()"><i
                  class="fa fa-download"></i></button>
            </div>
          </div>
          <div class="form-group" *ngIf="selectedValue3 == 'Samples'">
            <div class="form-group">
              <button class="btn btn-primary mt-0 mb-0 download" (click)="exportsamplesdata()"><i
                  class="fa fa-download"></i></button>
            </div>
          </div>
          <div class="form-group" *ngIf="selectedValue3 == 'Diagnostic'">
            <div class="form-group">
              <button class="btn btn-primary mt-0 mb-0 download" (click)="exportDiagnosticdata()"><i
                  class="fa fa-download"></i></button>
            </div>
          </div>
          <div class="form-group" *ngIf="selectedValue3 == 'Deworming'">
            <div class="form-group">
              <button class="btn btn-primary mt-0 mb-0 download" (click)="exportDewormingdata()"><i
                  class="fa fa-download"></i></button>
            </div>
          </div>
          <div class="form-group" *ngIf="selectedValue3 == 'Death'">
            <div class="form-group">
              <button class="btn btn-primary mt-0 mb-0 download" (click)="exportDeath()"><i
                  class="fa fa-download"></i></button>
            </div>
          </div>
        </div>

        <!--button for export-->
        <div class="col-lg-2 col-sm-6 col-12" [class.disablebutton]="isDisabled">
          <div class="form-group">
            <label>Upload XLSX Data</label>
            <select id="Upload" title="Upload XLSX Data" class="selectpicker form-control myFakeClass5"
              [(ngModel)]="selectedValue" (change)="stockmanagementapi()" data-size="5">
              <option selected disabled val="">Upload XLSX Data</option>
              <!-- <option value="General">General</option> -->
              <option value="Vaccine">Vaccine</option>
              <option value="Disease">Disease</option>
              <option value="Samples">Samples</option>
              <option value="Diagnostic">Diagnostic</option>
              <option value="Deworming">Deworming</option>
              <option value="Death">Death</option>
            </select>
          </div>
        </div>

        <!-- Upload XLSX File + Template -->
        <div class="col-lg-2 col-sm-6 col-12"
            [class.disablebutton1]="disablebutton1"
            style="margin-top:13px;">

            <div class="template-download-wrapper">

                <!-- Vaccine -->
                <div *ngIf="selectedValue == 'Vaccine'">
                    <span class="template-download-text"
                          (click)="downloadVaccineTemplate()">
                        Download Vaccine Template
                    </span>
                </div>

                <!-- Disease -->
                <div *ngIf="selectedValue == 'Disease'">
                    <span class="template-download-text"
                          (click)="downloadDiseaseTemplate()">
                        Download Disease Template
                    </span>
                </div>

                <!-- Samples -->
                <div *ngIf="selectedValue == 'Samples'">
                    <span class="template-download-text"
                          (click)="downloadSamplesTemplate()">
                        Download Samples Template
                    </span>
                </div>

                <!-- Diagnostic -->
                <div *ngIf="selectedValue == 'Diagnostic'">
                    <span class="template-download-text"
                          (click)="downloadDiagnosticTemplate()">
                        Download Diagnostic Template
                    </span>
                </div>

                <!-- Deworming -->
                <div *ngIf="selectedValue == 'Deworming'">
                    <span class="template-download-text"
                          (click)="downloadDewormingTemplate()">
                        Download Deworming Template
                    </span>
                </div>

                <!-- Death -->
                <div *ngIf="selectedValue == 'Death'">
                    <span class="template-download-text"
                          (click)="downloadDeathTemplate()">
                        Download Death Template
                    </span>
                </div>

            </div>

            <div class="upload-wrapper">

                <div class="form-group" *ngIf="selectedValue">

                    <input class="custom-file-input"
                          [id]="selectedValue"
                          (change)="importbulkdata($event)"
                          type="file">

                    <label class="custom-file-label" [for]="selectedValue">
                        Upload XLSX Data
                    </label>

                </div>

            </div>

        </div>
        
        <div class="col-lg-3 col-sm-6 col-12">
          <div class="form-group">
            <label for="Species Name"></label>
            <div class="input-group filter_with_search form-group">
              <span class="input-group-btn">
                <button class="btn btn-default" type="button"><span class="fa fa-search"></span></button>
              </span>
              <input type="text" id="speciessearch" class="form-control" value="" name="x" placeholder="Search term...">
              <div class="input-group-btn search-panel" data-search="students">
              </div>
            </div>
          </div>
        </div>


      </div>

      <div *ngIf="getStockListData || AnimalListID || farmuserlistanimalid!=''">
        <!--loader start-->
        <div class="loading-div" *ngIf="isLoading">
          <div class="loading-bar">
            <div class="lds-roller">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
            <p class="mt-3">Processing data. Please wait..</p>
          </div>
        </div>
        <!--loader end-->
        <div id="tablehide" style="height: 568px;">
          <table id="myTable" class="row-border hover ">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Farm Name</th>
                <th>Species Name</th>
                <th>Breed Name</th>
                <th>Age Group</th>
                <th>Animal ID</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="getStockListData!=false">
                <tr *ngFor="let specieslist of getStockListData; index as j">
                  <td>{{j+1}}</td>
                  <td>{{specieslist.farm_name}}</td>
                  <td>{{specieslist.species_name}}</td>
                  <td>{{specieslist.breed_name}}</td>
                  <td>{{specieslist.age_group}}</td>
                  <td>{{specieslist.tnsm_animal_code}}</td>
                  <td><i type="submit" class="btn size button"
                      id="{{specieslist.tnsm_animal_code}}_{{specieslist.tnsm_farm_id}}_{{specieslist.tnsm_species_id}}_{{specieslist.tnsm_breed_id}}_{{specieslist.tnsm_age}}"
                      (click)="animalcode($event)" class="fa fa-file-text icon_common" aria-hidden="true"></i></td>
                </tr>
              </ng-container>
              <ng-container *ngIf="AnimalListID!=false">
                <tr *ngFor="let specieslist of AnimalListID; index as j">
                  <td>{{j+1}}</td>
                  <td>{{specieslist.species_name}}</td>
                  <td>{{specieslist.breed_name}}</td>
                  <td>{{specieslist.tnsm_animal_code}}</td>
                  <td><i type="submit" class="btn size button"
                      id="{{specieslist.tnsm_animal_code}}_{{specieslist.tnsm_farm_id}}_{{specieslist.tnsm_species_id}}_{{specieslist.tnsm_breed_id}}_{{specieslist.tnsm_age}}"
                      (click)="animalcode($event)" class="fa fa-file-text icon_common" aria-hidden="true"></i></td>
                </tr>
              </ng-container>
              <ng-container *ngIf="farmuserlistanimalid!=false">
                <tr *ngFor='let specieslist of farmuserlistanimalid; index as j'>
                  <td>{{j+1}}</td>
                  <td>{{specieslist.species_name}}</td>
                  <td>{{specieslist.breed_name}}</td>
                  <td>{{specieslist.tnsm_animal_code}}</td>
                  <td>
                    <!--<button type="submit" class="btn size" ><i id="{{specieslist.tnsm_animal_code}}_{{specieslist.tnsm_farm_id}}"  (click)="animalcode($event)" class="fa fa-file-text icon_common"   aria-hidden="true"></i></button></td>-->

                    <i type="submit" class="btn size button"
                      id="{{specieslist.tnsm_animal_code}}_{{specieslist.tnsm_farm_id}}_{{specieslist.tnsm_species_id}}_{{specieslist.tnsm_breed_id}}_{{specieslist.tnsm_age}}"
                      (click)="animalcode($event)" class="fa fa-file-text icon_common" aria-hidden="true"></i>
                  </td>

                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>

    </div>
  </div>
</div>